import script from "./LoadBeforeClaimModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadBeforeClaimModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadBeforeClaimModal.vue?vue&type=style&index=0&id=3a7babea&lang=scss"

const __exports__ = script;

export default __exports__